export default __webpack_public_path__ + "static/media/Emprego-PT.06ed412c.png";